<div class="container-fluid container-lg g-0 g-lg-4">
  <ng-content></ng-content>
  <div class="row g-0 gx-lg-4">
    <ng-content select="x-page-panel"></ng-content>
  </div>
</div>
